import React, { useEffect, useState } from 'react';
import { Divider, Empty, Modal, Spin, Tooltip, Typography, Upload, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { ingestionApi } from '../ingestionApi';

const { Text } = Typography;

/**
 * "Replace image" for a variant: upload a file, or pick from all of the item's
 * pooled scraped images. Returns the choice via `onUploadFile(file)` /
 * `onPickUrl(url)`; the parent performs the actual replace + refresh.
 */
export const ReplaceImageDialog = ({ open, itemId, busy, onCancel, onUploadFile, onPickUrl }) => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!open || !itemId) return;
        setLoading(true);
        ingestionApi
            .getItemImages(itemId)
            .then((d) => setImages(d.images || []))
            .catch((e) => message.error(e.message || 'Failed to load images'))
            .finally(() => setLoading(false));
    }, [open, itemId]);

    return (
        <Modal title="Replace image" open={open} onCancel={onCancel} footer={null} width={640}>
            <Upload.Dragger
                accept="image/*"
                showUploadList={false}
                disabled={busy}
                beforeUpload={(file) => {
                    onUploadFile(file);
                    return false;
                }}
            >
                <p className="ant-upload-drag-icon" style={{ marginBottom: 4 }}>
                    <InboxOutlined />
                </p>
                <Text>Click or drag an image here to upload</Text>
            </Upload.Dragger>

            <Divider plain style={{ marginTop: 16 }}>
                or choose from the item's images
            </Divider>

            {loading ? (
                <div style={{ textAlign: 'center', padding: 24 }}>
                    <Spin />
                </div>
            ) : images.length === 0 ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No scraped images" />
            ) : (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, maxHeight: 300, overflowY: 'auto' }}>
                    {images.map((url) => (
                        <Tooltip key={url} title="Use this image">
                            <div
                                onClick={() => !busy && onPickUrl(url)}
                                style={{
                                    width: 88,
                                    height: 88,
                                    borderRadius: 4,
                                    overflow: 'hidden',
                                    border: '1px solid #eee',
                                    cursor: busy ? 'default' : 'pointer',
                                    opacity: busy ? 0.5 : 1,
                                }}
                            >
                                <img
                                    src={url}
                                    alt="candidate"
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                        </Tooltip>
                    ))}
                </div>
            )}
        </Modal>
    );
};
